import { reactive, ref } from "vue";

export const taskList = reactive(ref<Record<string|number, any>>({}));

export function callTaskList() {
    Object.values(taskList.value || {}).forEach(cb => (cb || (() => {}))?.());
}

let componentId = 1;
export function addTask(cb: any) {
    taskList.value[componentId] = cb;
    return componentId++;
}

export function removeTask(component_id: string) {
    if (taskList.value?.[component_id]) {
        taskList.value[component_id] = undefined;
    }
}
